<template>
  <div  style="width: 100%;min-width:996px" ref="chart" >

  </div>
</template>
<script>
import echarts from 'echarts';
import finance from '../services/finance';
import refund from '../services/refund';
import utils from '../libs/utils';

export default {
  name: 'charts',
  props: {
    type: {
      type: Number,
    },
    id: {
      type: String,
    },
  },
  data() {
    return {
      option: null,

    };
  },
  methods: {
    handleCharts(data) {
      const { nodes, links } = data;
      // console.log(nodes);

      links.forEach((item) => {
        item.lineStyle = {};
        // item.lineStyle.curveness = 0.1;
      });
      // const levelCount=0
      const levels = [];//-1,-1,0
      const parents = [];// main,main,R1576566571736
      nodes.forEach((val) => {
        levels.push(val.level);
        if (val.parentId) {
          parents.push(val.parentId);
        } else {
          val.parentId = 'main';
          parents.push('main');
        }
      });

      const sortArr = [...new Set(levels)].sort((a, b) => a - b);//升序排列,
      console.log(sortArr);

      const resArr = [];
      sortArr.forEach((level, index) => {
        resArr[index] = [];
        nodes.forEach((node) => {
          // console.log(node);

          node.itemStyle = {
            color: '#F8F8F9',
            borderColor: '#D9D9D9',
            borderWidth: '1',
          };
          // node.name = `${node.name.slice(0, 13)}...`;
          node.label = {
            normal: {
              color: '#595959',
              // formatter: [
              //   node.typeName,
              //   node.name,
              // ].join('\n'),
              formatter(item) {
                return `${item.name.slice(0, 13)}...`;
              },
            },
          };

          node.x = (node.level) * 800;
          node.y = 800;

          // 标识当前单据
          if (node.value === Number(this.id) && node.type === this.type) {//value是id，type是单据类型
            node.itemStyle.color = '#1890FF';
            node.label.normal.color = '#fff';
          }

          if (node.level === level) {
            resArr[index].push(node);
          }
        });
      });
      const tempArrtest = utils.deepClone(resArr);//resarr是根据level分层后的结构
      console.log(tempArrtest);
      // console.log('-------------');

      for (let i = 1; i < resArr.length; i++) {
        const tempArr = [];
        const lastArr = [];
        resArr[i - 1].forEach((el) => {
          resArr[i].forEach((item) => {
            if (item.parentId === el.id) {
              tempArr.push(item);
            }
          });
        });
        if (resArr[i].length !== tempArr.length) {
          console.log(tempArr);
          resArr[i].forEach((el) => {
            el.exist = false;
            tempArr.forEach((item) => {
              if (item.id === el.id) {
                el.exist = true;
              }
            });
            if (!el.exist) {
              lastArr.push(el);
            }
          });
        }

        console.log(lastArr);

        resArr[i] = tempArr.concat(lastArr);
      }
      const nodesFinal = [];
      console.log(resArr);
      let tempMax = 0;
      resArr.forEach((arr) => {
        if (arr.length > tempMax) {
          tempMax = arr.length;
        }
        arr.forEach((item, i) => {
          item.y = i * 210;
          nodesFinal.push(item);
        });
      });
      this.$refs.chart.style.height = `${300 + (tempMax - 1) * 66}px`;
      // console.dir(this.$refs.chart);
      const chart = echarts.init(this.$refs.chart, {
        // height: `${300 + (tempMax - 1) * 66}px`,
        // width:null
      });
      // console.log(tempMax);

      this.option = {
        title: {
          text: '单据拓扑图',
        },
        tooltip: {},
        // animationDurationUpdate: 1500,
        animationEasingUpdate: 'quinticInOut',
        // dataZoom: [
        //     {
        //     type: 'inside',
        //     // xAxisIndex: [0],
        //     // start: 1,
        //     // end: 35,
        //     disabled:true
        // },
        // ],
        series: [
          {
            type: 'graph',
            layout: 'none',
            // symbolSize: 50,
            nodeScaleRatio: 0,
            roam: false,
            focusNodeAdjacency: true,
            draggable: true,
            // symbol:'image://http://lorempixel.com/400/200/sports/1/',
            symbol: 'rect',
            symbolSize: [112, 44],
            // layout: 'force',
            // force: {
            //       repulsion: 100
            //   },
            // silent: true,
            label: {
              normal: {
                show: true,
              },
            },
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [4, 10],
            edgeLabel: {
              normal: {
                textStyle: {
                  fontSize: 20,
                },
              },
            },
            data: nodesFinal,
            animation: false,
            // links: [],
            links,
            lineStyle: {
              color: '#595959 ',
              // curveness: 0.1
            },
          },
        ],
      };
      chart.setOption(this.option);
      chart.on('click', (params) => {
        this.$emit('handleClick', params);

        this.option.series[0].data.forEach((item) => {
          // console.log(item);
          if (item.id === params.data.id) {
            item.itemStyle.color = '#1890FF';
            item.label.normal.color = '#fff';
          } else {
            item.itemStyle.color = '#F8F8F9';
            item.label.normal.color = '#595959';
          }
        });
        chart.setOption(this.option);


        // console.log(this.option);
      });
    },
    getData() {
      // axios.defaults.baseURL = '/test';
      if (this.$route.name === 'payableCheck') {
        finance.getPayableChart({ financePayableId: this.id }).then((res) => {
          if (res.data.status === 200) {
            this.handleCharts(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else if (this.$route.name === 'paymentCheck') {
        finance.getPaymentChart({ financePaymentId: this.id }).then((res) => {
          if (res.data.status === 200) {
            this.handleCharts(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else if (this.$route.name === 'refundSheet') { // 供应商退货
        refund.purchaseRefundChart({ purchaseRefundId: this.id }).then((res) => {
          if (res.data.status === 200) {
            this.handleCharts(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    },
  },
  mounted() {
    this.getData();
    // const chart = echarts.init(this.$refs.chart);
  },
};
</script>
